/**
 * Allowed file types in options
 */

export default {
  images: ".jpg,.jpeg,.png,.gif",
  docs: ".doc,.docx,.pdf,.ppt,.pptx",
  video: ".mp4,.m4p,.m4v,.avi,.mov,.webm,.kmv,.flv,.ogg,.gif",
};
